import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyMarketKey,
  ShopifyMarketRegionKey,
  ShopifyMarketRegionToMarketKey,
  ShopifyMarketRegionToShopKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyMarketRegionKey,
  "2022-04": {
    name: "Shopify Market Region",
    graphQLTypename: "MarketRegion",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
          },
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "name",
            graphQLFieldKey: "name",
          },
        },
      },
      {
        name: "Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "code",
            graphQLFieldKey: "code",
            graphQLFragments: ["MarketRegionCountry"],
          },
        },
      },
      {
        name: "Market",
        fieldType: FieldType.BelongsTo,
        key: ShopifyMarketRegionToMarketKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "market",
            skipGraphQLSelection: true,
          },
        },
        configuration: {
          relatedModelKey: ShopifyMarketKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyMarketRegionToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "graphql_sublist",
      parent: "markets",
      resource: "market.regions",
    },
  },
};

export const ShopifyMarketRegion = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
